/**
 * appAccess — single helper for the /app route access rule.
 *
 * Access is granted when EITHER:
 *   1. A legacy session token is present (cloud / web-service login path), OR
 *   2. The app was started in iframe mode (embedded plugin admin, no cloud token
 *      needed — auth is handled by the gateway session bridge).
 *
 * Keeping this rule in one place prevents it from diverging between
 * RestrictedRoute and any future guard locations.
 *
 * @param {object} params
 * @param {string|null|undefined} params.sessionToken  - Legacy session token
 * @param {boolean}               params.inIframeStartMode - true when startMode==='iframe'
 * @returns {boolean}
 */
export function canAccessApp({ sessionToken, inIframeStartMode }) {
  if (sessionToken) return true;
  if (inIframeStartMode) return true;
  return false;
}
